import {AxiosResponse} from 'axios';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import ApiService from '@/services/api.service';
import {ForestGame} from '@/library/forest-game/forest-game';

export default class ForestGameService {

    public isSummaryOpened: boolean = true;
    private static instance: ForestGameService;
    private apiService: ApiService = ApiService.getInstance();

    private constructor() {
    }

    public static getInstance(): ForestGameService {
        if (!ForestGameService.instance) {
            ForestGameService.instance = new ForestGameService();
        }
        return ForestGameService.instance;
    }

    public hideSummary(): void {
        this.isSummaryOpened = false;
    }

    public showSummary(): void {
        this.isSummaryOpened = true;
    }

    public sendAnswers(formData: FormData): Observable<AxiosResponse> {
        return this.apiService.forestGameSendAnswer(formData);
    }

    public startGame(game: ForestGame): Observable<AxiosResponse> {
        return this.apiService.forestGameStart(game.id()).pipe(
            map((response: AxiosResponse) => {
                this.hideSummary();
                return response;
            }),
        );
    }

    public result(game: ForestGame): Observable<AxiosResponse> {
        return this.apiService.forestGameResult(game.id()).pipe(
            map((response: AxiosResponse) => {
                return response;
            }),
        );
    }
}
